
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="场次">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.memberstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">联系人信息</a-select-option>
                <a-select-option value="6">报名成功</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"  >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="applyDeleteAll()" key="1"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>


      <a-button @click="download(1)" style="margin-left: 8px"  >
        报名信息表 <a-icon type="download" />
      </a-button>
      <a-button @click="download(2)" style="margin-left: 8px"  >
        人员信息表 <a-icon type="download" />
      </a-button>
      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeUpload"
          style="margin-left: 8px;display: inline-block"
      >
        <a-button>
          回传信息表
          <a-icon type="upload"/>
        </a-button>
      </a-upload>



    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}
            <br/>
            <a-tag v-if="record.pay_type_name" color="cyan">
            {{record.pay_type_name}}
              </a-tag>
            <span style="color: #999">{{record.ldname}} </span>
            <br/>
            {{record.create_time|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{record.saiqu_name}}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.memberstatus==1" >联系人信息</a-tag>
        <a-tag v-if="record.memberstatus==2" >人员信息</a-tag>
        <a-tag v-if="record.memberstatus==3" >申报信息</a-tag>
        <a-tag v-if="record.memberstatus==4" color="red">确认订单</a-tag>
        <a-tag v-else-if="record.memberstatus==6" color="green">报名成功</a-tag>
        <br/>
        <a-tag v-if="record.pay_status==1">未支付</a-tag>
        <a-tag v-else-if="record.pay_status==2" color="blue">已付款</a-tag>

      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
            >
            <a-input v-model="formData.danwei"
                     placeholder="请输入单位名称"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系人"
                      hasFeedback
              >
                <a-input v-model="formData.ldname"
                          placeholder="请输入联系人"/>
              </a-form-item>

              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="微信号"
                      hasFeedback
              >
                <a-input v-model="formData.weixin"
                         placeholder="请输入微信号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机号"
                      hasFeedback
              >
                <a-input v-model="formData.phone"
                         placeholder="请输入手机号"/>
              </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="邮箱"
                      hasFeedback
              >
                <a-input v-model="formData.email"
                         placeholder="请输入邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="省市"
                      hasFeedback
              >

                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect />

              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="地址"
                      hasFeedback
              >
                <a-input v-model="formData.address"
                         placeholder="请输入详细地址"/>
              </a-form-item>
              </a-col>
            </a-row>

            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="报名状态"
                      hasFeedback
              >
              <a-radio-group v-model="formData.memberstatus" button-style="solid">
                <a-radio-button :value="1">
                  联系人信息
                </a-radio-button>
                <a-radio-button :value="6"  >
                  报名成功
                </a-radio-button>
              </a-radio-group>

            </a-form-item>
              </a-col>
          </a-row>


          <a-divider>人员信息</a-divider>
          <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record" >
              {{record.name}} ({{record.sex}})
              <br/>
              {{record.num}}
              <br/>
              <span v-show="record.chengji">成绩：{{record.chengji}}</span>
              <span v-show="record.cpj_chengji">裁判长成绩：{{record.cpj_chengji}}</span>
            </p>
            <p slot="service" slot-scope="text,record" >
              ({{record.service_name}}) ¥{{record.price}}
            </p>
            <template slot="action" slot-scope="text,record,index">
              <a href="javascript:;" @click="onEditUser(record)">编辑</a>
              <a-divider type="vertical" />
            </template>
          </a-table>

          <a-divider>物料信息</a-divider>

          <a-table :columns="goodsColumns" :data-source="formData.goods_list" :pagination="false">
          </a-table>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="人员操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userFormVisible"
        @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'sex',
              {rules: [{ required: true, message: '请输入性别' }]}
            ]"
                          placeholder="请输入性别"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入手机' }]}
            ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="成绩"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'chengji',
              {rules: [ ]}
            ]"
                          placeholder="请输入成绩"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="裁判长成绩"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'cpj_chengji',
              {rules: [ ]}
            ]"
                          placeholder="请输入裁判长成绩"/>
              </a-form-item>
            </a-col>
          </a-row>



          <a-row :gutter="48" v-if="false">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="服务套餐"
                  hasFeedback
              >

                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="userFormData.service_id"
                    placeholder="选择服务套餐"
                    allowClear
                >
                  <a-select-option v-for="(option,index) in serviceTypeOptions" :value="option.id">{{option.name}}</a-select-option>

                </a-select>

              </a-form-item>
            </a-col>

          </a-row>


          <a-divider>申报信息</a-divider>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有裁判等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipandengjiwudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报裁判等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipanshenbaowudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有裁判等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipandengjijiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报裁判等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipanshenbaojiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有教练等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaoliandengjiwudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报教练等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaolianshenbaowudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有教练等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaoliandengjijiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报教练等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaolianshenbaojiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="经历描述"
                  hasFeedback
              >
                <a-textarea
                    v-model="userFormData.experience_desc"
                    :row="2"
                    placeholder="请输入带队经历和执裁经历..."/>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>
      </a-spin>

      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量回传信息"
        v-model="taskInfoShow"
    >
      <a-badge status="success" :text="'检测成功 '+(taskInfo.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'检测失败 '+(taskInfo.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo.members.length) "/>
      </p>
      <a-progress :percent="taskInfo.percent"/>
      </p>
    </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import CaipanPicker from '@/components/CaipanPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import qs from 'qs'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getApplyList ,getApplyDetail,editApply ,applyDelete ,sjsqOptions, getApplyUserDetail, editApplyUser, editSongpeiOrderItem,checkSongpeiOrderOK } from '@/api/songpei'
  import XLSX from "xlsx";
  import {checkShengMemberOK, shengjlApply} from "@/api/jiaolian";
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      CaipanPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        orderVisible: false,
        saveLoading:false,
        userFormVisible:false,
        taskInfoShow:false,
        jiaolianPickerShow:false,
        caipanPickerShow:false,
        sjsqOptions:[],
        orderFormData:{
          pics:[]
        },
        formData:{
          id:0,
          danwei:'',
          areas:[],
          member_list:[],
          loglist:[],
          fapiao_list:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form3: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '报名信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '场次',
            dataIndex: 'saiqu',
            scopedSlots: { customRender: 'saiqu' +
            '' },
          },
          {
            title: '进度',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 220,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 表头
        goodsColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'item_title',
          },
          {
            title: '价格',
            dataIndex: 'price',
          },
          {
            title: '数量',
            dataIndex: 'count',
          },
        ],
        // 表头
        subjectColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '姓名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '电话',
            dataIndex: 'phone',
          },
          {
            title: '微信',
            dataIndex: 'weixin',
          },
          // {
          //   title: '套餐',
          //   dataIndex: 'service',
          //   scopedSlots: { customRender: 'service' },
          // },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 发票
        fapiaoColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '抬头',
            dataIndex: 'fapiao_taitou',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '发票信息',
            dataIndex: 'fapiao',
            scopedSlots: { customRender: 'fapiao' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },
        serviceTypeOptions:[],
        userFormData:{
          id:0,
          name:'',
          experience_desc: '',
          "caipandengjiwudao":"",
          "caipandengjijiqiao":"",
          "jiaoliandengjiwudao":"",
          "jiaoliandengjijiqiao":"",
          "caipanshenbaowudao":"",
          "caipanshenbaojiqiao":"",
          "jiaolianshenbaowudao":"",
          "jiaolianshenbaojiqiao":"",
        },

        taskInfo: {
          members: [],
          errors: [],
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          percent: 0,
          doing: false,
        },
      }
    },
    computed:{
    },

    created(){
    },

    mounted(){
      let that = this;

      let query  = this.$route.query;
      // 6, 276
      console.log(query)
      if(query.saiji) {
        this.queryParam.sjsq = [query.saiji, query.saiqu]
      }
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      handleOrderCancel(){
        this.orderVisible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },



      handleEdit(record){
        let self = this
        this.visible = true
        getApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      handleOrderEdit(record){
        let self = this
        getApplyOrderDetail({ baoming_id: record.id }).then(res => {
          self.orderVisible = true
          setTimeout(() =>{
            self.orderFormData.id = record.id;
            console.log('handleEdit')

            self.orderFormData = { ...res.data };
          },200)
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editApply({
              id:self.formData.id,
              danwei:self.formData.danwei,
              ldname:self.formData.ldname,
              weixin:self.formData.weixin,
              email:self.formData.email,
              phone:self.formData.phone,
              fapiao_taitou:self.formData.fapiao_taitou,
              fapiao_shuihao:self.formData.fapiao_shuihao,
              fapiao_beizhu:self.formData.fapiao_beizhu,
              fapiao_email:self.formData.fapiao_email,
              fapiao_phone:self.formData.fapiao_phone,
              memberstatus:self.formData.memberstatus,
              area:self.formData.areas[self.formData.areas.length-1],
              address:self.formData.address,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh()
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },
      // 增改 处理
      handleOrderOk(e) {
        let self = this;
        e.preventDefault();

        self.saveLoading = true;
        editApplyOrder({
          id:self.orderFormData.id,
          baoming_id:self.orderFormData.baoming_id,
          status:self.orderFormData.status,
          adminnote:self.orderFormData.adminnote,
          memberprice:self.orderFormData.memberprice,
          pay_price:self.orderFormData.pay_price,
          pics:self.orderFormData.pics,
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh()
          self.orderVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },

      // 删
      applyDelete(record) {
        let self = this
        applyDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      // 删
      applyDeleteAll() {
        let self = this
        applyDelete({ ids: self.selectedRowKeys ,id:0 }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },


      onEditUser(record){
        let self = this
        this.userFormVisible = true
        getApplyUserDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form3.setFieldsValue({ ...res.data })
            self.userFormData.id = record.id;
            self.userFormData = { ...res.data };
          },200)
        });
        // getServiceTypeList({ saiqu: self.formData.saiqu }).then(res => {
        //   setTimeout(() =>{
        //     self.serviceTypeOptions = res.data
        //   },200)
        // });
      },
      handleUserFormCancel(){
        this.userFormVisible = false
      },


      handleUserFormOk(e) {
        let self = this;
        e.preventDefault()
        this.form3.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.userFormData)
            self.saveLoading = true;
            editApplyUser({
              id:self.userFormData.id,
              name:values.name,
              num:values.num,
              phone:values.phone,
              chengji:values.chengji,
              cpj_chengji:values.cpj_chengji,
              sex:values.sex,
              service_id:self.userFormData.service_id,
              caipandengjiwudao:self.userFormData.caipandengjiwudao,
              caipandengjijiqiao:self.userFormData.caipandengjijiqiao,
              jiaoliandengjiwudao:self.userFormData.jiaoliandengjiwudao,
              jiaoliandengjijiqiao:self.userFormData.jiaoliandengjijiqiao,
              caipanshenbaowudao:self.userFormData.caipanshenbaowudao,
              caipanshenbaojiqiao:self.userFormData.caipanshenbaojiqiao,
              jiaolianshenbaowudao:self.userFormData.jiaolianshenbaowudao,
              jiaolianshenbaojiqiao:self.userFormData.jiaolianshenbaojiqiao,
              experience_desc:self.userFormData.experience_desc,
            }).then(res => {
              self.$message.success('修改成功')
              self.userFormVisible = false;
              self.saveLoading = false;
              self.handleEdit({id:self.formData.id});
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })

          }
        })
      },

      beforeUpload(file) {
        let that = this
        let formdata = new FormData()
        console.log(file)
        formdata.append('upfile', file)
        formdata.append('action', 'test')
        // console.log('formdata', formdata)
        if (this.queryParam.sjsq.length != 2) {
          // that.$message.error('请先选择场次')
          // return false;
        }

        this.file2Xce(file).then(tabJson => {
          if (tabJson && tabJson.length > 0) {
            // this.xlsxJson = tabJson
            console.log('this.xlsxJson', tabJson,  tabJson[0].sheet[0].__EMPTY_1);
            // return
            // if (typeof tabJson[0].sheet[0].__EMPTY_12 == 'undefined' || tabJson[0].sheet[0].__EMPTY_12 != "版本2021001") {
            //   that.$message.error('文件版本不正确');
            //   return;
            // }
            // return ;

            let userList = [];
            tabJson[0].sheet.map((item, index) => {

              let sheetRow = []
              Object.keys(item).map(name => {
                // console.log('itemRow', name)
                if (index >=0 && name.indexOf('sku_id=') >= 0)  {

                  let skuRow = name.split('sku_id=')

                  console.log('itemRow', name, item[name])

                  sheetRow.push({
                    sku_id: skuRow[1],
                    baoming_id: item["报名ID"],
                    count: item[name],
                  })
                }
              })

              // 如何动态判断表头呢？
              userList.push(sheetRow)
            })

            /**
             * userList: {
             *  id: 0,
             *  list: []
             * }
             */

            console.log('userList', userList);
            // return ;


            that.taskInfo = {
              members: userList,
              currentIndex: 0,
              scount: 0,
              fcount: 0,
              errors: [],
              doing: true,
            }
            that.taskInfoShow = true;
            that.doTask2(that.taskInfo);

          }
        });

        /*
        expressImport(formdata)
          .then(res => {
            that.$message.success('上传成功')
            that.$refs.table.refresh(true)
          })
          .catch(err => {
            that.$message.error(err.data.msg)
          })*/
        return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
      },

      file2Xce(file) {
        return new Promise(function (resolve, reject) {
          const reader = new FileReader()
          reader.onload = function (e) {
            const data = e.target.result
            this.wb = XLSX.read(data, {
              type: 'binary'
            })
            const result = []
            this.wb.SheetNames.forEach((sheetName) => {
              result.push({
                sheetName: sheetName,
                sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
              })
            })

            console.log('解析出来的数据', result)
            // return
            resolve(result)
          }
          // reader.readAsBinaryString(file.raw)
          reader.readAsBinaryString(file) // 传统input方法
        })
      },

      doTask2(taskInfo) {
        let that = this;
        if (taskInfo.currentIndex >= taskInfo.members.length) {
          taskInfo.doing = false;
          //结束
          if (taskInfo.fcount == 0) {
            editSongpeiOrderItem({
              list: JSON.stringify(taskInfo.members),
            }).then(res => {
              that.taskInfoShow = false;
              that.$message.success('修改成功')
              that.$refs.table.refresh(true)
            });
          }
          return false;
        }
        checkSongpeiOrderOK({
          id: taskInfo.members[taskInfo.currentIndex].id,
        }).then(res => {
          if (res.data.length > 0) {
            taskInfo.fcount++;
            taskInfo.errors = taskInfo.errors.concat(res.data);
            taskInfo.currentIndex++;
          } else {
            taskInfo.scount++;
            taskInfo.currentIndex++;
            console.log(taskInfo.currentIndex);
            if (taskInfo.currentIndex == (taskInfo.members.length)) {
            }
          }
          taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.members.length) * 100).toFixed(1);
          that.doTask2(taskInfo)
        }).catch(err => {
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.members.length) * 100).toFixed(1);
          that.doTask2(taskInfo)
        });
      },

      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择场次');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/adminapi/songpei/applyDownload?saiqu='+qs.stringify(this.queryParam));
            break;
          case 2:
            window.open(setting.apiBaseURL+'/adminapi/songpei/memberDownload?saiqu='+qs.stringify(this.queryParam));
            break;
          case 3:
            window.open(setting.apiBaseURL+'/adminapi/sai/rysfzDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 4:
            window.open(setting.apiBaseURL+'/adminapi/sai/csrstjDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 5:
            window.open(setting.apiBaseURL+'/adminapi/sai/zhixuceDownload?saiqu='+this.queryParam.sjsq[1]+'&memberstatus='+(this.queryParam.memberstatus||0));
            break;
          case 6:
            window.open(setting.apiBaseURL+'/adminapi/sai/caiwuDownload?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },
      onFapiaoDownload(record){
        window.open(record.pdf_url);
      },
      onFapiaoZuofei(record){
        let self = this
        fapiaoZuofei({ id: record.id }).then(res => {
          self.handleEdit({ id: record.baoming_id})
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onRefreshFapiao(record){
        let self = this
        refreshFapiao({ fapiao_id: record.id }).then(res => {
          self.handleEdit({ id: record.baoming_id})
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      sjsqFilter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
